'use es6';

import { connect } from 'react-redux';
import { getHasVideoIntegrationScope } from 'FileManagerCore/selectors/Auth';
import { getPortalHasOptedInOrOut, wasPortalOptedInByDefault } from 'FileManagerCore/selectors/Video2OptInStatus';
import Video2EnabledByDefault from './alerts/Video2EnabledByDefault';
import VideoLimitBanner from './video/VideoLimitBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashboardHeaderAlerts = ({
  hasVideoIntegrationScope,
  wasOptedInByDefault
}) => {
  const renderVideoWelcome = () => {
    if (!hasVideoIntegrationScope || typeof wasOptedInByDefault !== 'boolean') {
      return null;
    }
    if (wasOptedInByDefault) {
      return /*#__PURE__*/_jsx(Video2EnabledByDefault, {});
    }
    return null;
  };
  const renderOtherVideoAlerts = () => {
    if (hasVideoIntegrationScope) {
      return /*#__PURE__*/_jsx(VideoLimitBanner, {});
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderVideoWelcome(), renderOtherVideoAlerts()]
  });
};
const mapStateToProps = state => ({
  hasOptedInOrOut: getPortalHasOptedInOrOut(state),
  hasVideoIntegrationScope: getHasVideoIntegrationScope(state),
  wasOptedInByDefault: wasPortalOptedInByDefault(state)
});
export default connect(mapStateToProps)(DashboardHeaderAlerts);